import { Constants, WebFormMode } from '@dx-ui/dx-common';
import { useEffect, useMemo, useState } from 'react';
import {
  Loading,
  linkToRecord,
  useDataProvider,
  useNotify,
  useRedirect,
} from 'react-admin';
import { useRouteMatch } from 'react-router-dom';
import {
  DocumentServiceFactory,
  ReceiptAdviceService,
  ReceiptAdviceServiceCreator,
} from '../../services';

const ReceiptAdviceCreate = (props) => {
  const dataProvider = useDataProvider();
  const [data, setData] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);
  const redirect = useRedirect();
  const match: any = useRouteMatch();
  const notify = useNotify();

  const { recipientId } = match.params;

  const receiptAdviceService: ReceiptAdviceService = useMemo(
    () =>
      DocumentServiceFactory.create(
        ReceiptAdviceServiceCreator,
        dataProvider
      ) as ReceiptAdviceService,
    [dataProvider]
  );

  useEffect(() => {
    const createNewReceiptAdvice = async () => {
      setLoading(true);
      try {
        const nodeId: string | undefined = await receiptAdviceService.createNew(
          recipientId
        );

        setData(nodeId);
        setLoading(false);
        redirect(
          `/${linkToRecord(Constants.RESOURCE_WEBRECEIPT_ADVICE, nodeId)}`,
          undefined, // basePath
          undefined, // id
          undefined, // data
          { redirectMode: WebFormMode.SCRATCH_RECEIPT_ADVICE } // state
        );
      } catch (e) {
        notify(
          'dxMessages.dashboard.OnErrorContactSupport',
          'error',
          { error: e },
          true
        );
        setLoading(false);
      }
    };
    if (!data) {
      createNewReceiptAdvice();
    }
  }, [data, notify, receiptAdviceService, recipientId, redirect]);
  if (loading) {
    return <Loading />;
  } else return null;
};

export default ReceiptAdviceCreate;
